import React from 'react';
import { FormFieldContainer } from '../../components';
import { checkCondition } from '../../helpers';

export const ConditionalFields = ({ field = {}, formik }) => {
  const { conditionConfig = {} } = field;
  const isConditionMet = checkCondition(formik?.values, conditionConfig);

  if (isConditionMet) {
    // Handle custom fields for conditional fields
    if (field?.type === 'custom' && field.Field) {
      return <field.Field formik={formik} {...field?.props} />;
    }
    return <FormFieldContainer item={field} formik={formik} />;
  } else return null;
};
